export class TipoElemModel {
    Codigo: number;
    Nombre: string;

    constructor(codigo: number, nombre: string) {
        this.Codigo = codigo;
        this.Nombre = nombre;
    }
}
